import { Observable } from "rxjs";
import { MenuOption } from "../../models/menu-option";
import { ProfessionType } from "../../models/profession-type";

export abstract class SpecialtyService {
  abstract getMGMASpecialtiesAsMenuOptions(professionType: ProfessionType): Observable<MenuOption[]>;
}
